"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZipModule = void 0;
const service_1 = require("./service/service");
const bad_request_1 = require("../errors/bad-request");
const file_1 = require("./file");
const p_queue_1 = __importStar(require("@esm2cjs/p-queue"));
const common_1 = require("./common");
const plugin_1 = require("../plugin");
const logger_1 = require("../logger");
class ZipModule {
    constructor(wallet, api) {
        this.events = ["ZIP_DECOMPRESSED", "ZIP_SIGNED", "ZIP_COMMITTED", "ZIP_FAILED"];
        this.service = new service_1.Service(wallet, api);
    }
    list(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.service.api.getZipLogs(options);
        });
    }
    /**
     * @param  {ListFileOptions} options
     * @returns Promise with list of all files per query options
     */
    listAll(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = (listOptions) => __awaiter(this, void 0, void 0, function* () {
                return yield this.list(listOptions);
            });
            return yield (0, common_1.paginate)(list, options);
        });
    }
    /**
     * @param  {string} vaultId
     * @param  {string} name folder name
     * @param  {ZipUploadOptions} [options] parent id, etc.
     */
    upload(vaultId, fileSource, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.service.setVaultContext(vaultId);
            if (!this.service.vault.public) {
                throw new bad_request_1.BadRequest("Zip upload is not supported for private vaults.");
            }
            const file = yield (0, file_1.createFileLike)(fileSource, {
                name: "zip",
            });
            if (options.chunkSize && options.chunkSize > file.size) {
                throw new bad_request_1.BadRequest("Chunk size can not be larger than the file size");
            }
            const chunkSize = (_a = options.chunkSize) !== null && _a !== void 0 ? _a : file_1.DEFAULT_CHUNK_SIZE_IN_BYTES;
            if (chunkSize < file_1.MINIMAL_CHUNK_SIZE_IN_BYTES) {
                throw new bad_request_1.BadRequest("Chunk size can not be smaller than: " +
                    file_1.MINIMAL_CHUNK_SIZE_IN_BYTES / file_1.BYTES_IN_MB);
            }
            if (file.size > chunkSize) {
                options.chunkSize = chunkSize;
                return yield this.multipartUpload(file, vaultId, options);
            }
            else {
                return yield this.simpleUpload(file, vaultId, options);
            }
        });
    }
    subscribe(next, error) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!plugin_1.Plugins.registered.has(plugin_1.PluginKey.PUBSUB)) {
                logger_1.Logger.warn("PubSub plugins is unregistered. Please install @akord/akord-js-pubsub-plugin and include it in plugins list when initializing SDK");
                return;
            }
            const address = yield this.service.wallet.getAddress();
            yield plugin_1.Plugins.registered.get(plugin_1.PluginKey.PUBSUB).use({
                action: "subscribe",
                filter: {
                    event: { in: this.events },
                    toAddress: { eq: address },
                },
                next,
                error,
            });
        });
    }
    unsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!plugin_1.Plugins.registered.has(plugin_1.PluginKey.PUBSUB)) {
                logger_1.Logger.warn("PubSub plugins is unregistered. Please install @akord/akord-js-pubsub-plugin and include it in plugins list when initializing SDK");
                return;
            }
            const address = yield this.service.wallet.getAddress();
            yield plugin_1.Plugins.registered.get(plugin_1.PluginKey.PUBSUB).use({
                action: "unsubscribe",
                filter: {
                    event: { in: this.events },
                    toAddress: { eq: address },
                },
            });
        });
    }
    simpleUpload(file, vaultId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const buffer = yield file.arrayBuffer();
            return yield this.service.api.uploadZip(buffer, vaultId, options);
        });
    }
    multipartUpload(file, vaultId, options) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const { chunkSize, chunksConcurrency } = options, initOptions = __rest(options, ["chunkSize", "chunksConcurrency"]);
            const { multipartToken } = yield this.service.api.uploadZip(null, vaultId, Object.assign(Object.assign({}, initOptions), { multipartInit: true }));
            let offset = 0;
            let partNumber = 1;
            const chunksQ = new p_queue_1.default({
                concurrency: options.chunksConcurrency || file_1.CHUNKS_CONCURRENCY,
            });
            const chunks = [];
            const apiOptions = {
                multipartToken: multipartToken,
                cancelHook: options.cancelHook,
                progressHook: options.progressHook,
            };
            while (offset < file.size) {
                const buffer = yield file
                    .slice(offset, offset + options.chunkSize)
                    .arrayBuffer();
                const currentPart = partNumber;
                chunks.push(() => this.service.api.uploadZip(buffer, vaultId, Object.assign(Object.assign(Object.assign({}, apiOptions), initOptions), { partNumber: currentPart, multipartToken: multipartToken })));
                offset += options.chunkSize;
                partNumber += 1;
            }
            try {
                yield chunksQ.addAll(chunks, {
                    signal: (_a = options.cancelHook) === null || _a === void 0 ? void 0 : _a.signal,
                });
            }
            catch (error) {
                if (!(error instanceof p_queue_1.AbortError) &&
                    !((_c = (_b = options.cancelHook) === null || _b === void 0 ? void 0 : _b.signal) === null || _c === void 0 ? void 0 : _c.aborted)) {
                    throw error;
                }
            }
            if ((_e = (_d = options.cancelHook) === null || _d === void 0 ? void 0 : _d.signal) === null || _e === void 0 ? void 0 : _e.aborted) {
                throw new p_queue_1.AbortError();
            }
            const { sourceId } = yield this.service.api.uploadZip(null, vaultId, Object.assign({ multipartToken: multipartToken, multipartComplete: true }, initOptions));
            return { sourceId };
        });
    }
}
exports.ZipModule = ZipModule;
